// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMToggle.tsx — PropelMapper switch. Pine when on; --pm-focus-ring on focus.

const PMTGL_CSS = `
.pmtgl{box-sizing:border-box;position:relative;display:inline-block;width:38px;height:22px;border-radius:999px;background:var(--pm-border-dark);cursor:pointer;border:none;padding:0;transition:.15s;flex:0 0 38px;vertical-align:middle}
.pmtgl::after{content:"";position:absolute;top:2px;left:2px;width:18px;height:18px;border-radius:50%;background:#fff;transition:.15s;box-shadow:var(--pm-shadow-xs)}
.pmtgl.is-on{background:var(--pm-primary)}
.pmtgl.is-on::after{left:18px}
.pmtgl:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmtgl[disabled]{opacity:.5;cursor:default}
`;
function pmtglEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmtgl-css")) return;
  const s = document.createElement("style"); s.id = "pmtgl-css"; s.textContent = PMTGL_CSS;
  document.head.appendChild(s);
}
export function PMToggle({ checked = false, onChange, disabled = false, "aria-label": ariaLabel, className = "", style = {}, ...rest }) {
  pmtglEnsureCSS();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={"pmtgl" + (checked ? " is-on" : "") + (className ? " " + className : "")}
      style={style}
      onClick={() => onChange && onChange(!checked)}
      {...rest}
    />
  );
}
